import { Page } from "@jkast90/kast-common/ui";
import { BugReportPage as Report } from "@common/account";

/**
 * /bug-report: reports go to the kast-dev admin inbox, not salvagers-api.
 * Pre-filled with the crash when arriving from the crash screen.
 */
export default function BugReportPage() {
  return (
    <Page as="main">
      <Report title="Report a bug" logsTitle="Attached logs" />
    </Page>
  );
}
